import * as React from "react";

import primaryColour from "../../constants";

function SvgAbs(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.06572 6.3157C2.78835 9.59307 2.78835 14.9068 6.06572 18.1841L4.93435 19.3155C1.03214 15.4133 1.03214 9.08654 4.93435 5.18433L6.06572 6.3157Z"
        fill={fill}
      />
      <path
        d="M17.9341 6.3157C21.2115 9.59307 21.2115 14.9068 17.9341 18.1841L19.0655 19.3155C22.9677 15.4133 22.9677 9.08654 19.0655 5.18433L17.9341 6.3157Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5728 8.20885V16.2967H12.5417C13.4254 16.2967 14.1417 15.5804 14.1417 14.6967V13.2528C14.1417 12.8744 14.0103 12.5267 13.7907 12.2528C14.0103 11.9788 14.1417 11.6311 14.1417 11.2527V9.80885C14.1417 8.9252 13.4254 8.20885 12.5417 8.20885H10.5728ZM11.7728 11.6527V9.40885H12.5417C12.7626 9.40885 12.9417 9.58794 12.9417 9.80885V11.2527C12.9417 11.4736 12.7626 11.6527 12.5417 11.6527H11.7728ZM11.7728 15.0967V12.8528H12.5417C12.7626 12.8528 12.9417 13.0319 12.9417 13.2528V14.6967C12.9417 14.9176 12.7626 15.0967 12.5417 15.0967H11.7728Z"
        fill={fill}
      />
      <path
        d="M16.4391 8.20885C15.5555 8.20885 14.8391 8.9252 14.8391 9.80886V11.2527C14.8391 12.1364 15.5555 12.8527 16.4391 12.8527L16.8081 12.8528C17.029 12.8528 17.2081 13.0319 17.2081 13.2528V14.6967C17.2081 14.9176 17.029 15.0967 16.8081 15.0967H16.4391C16.2182 15.0967 16.0391 14.9176 16.0391 14.6967V13.9748H14.8391V14.6967C14.8391 15.5804 15.5555 16.2967 16.4391 16.2967H16.8081C17.6917 16.2967 18.4081 15.5804 18.4081 14.6967V13.2528C18.4081 12.3692 17.6917 11.6528 16.8081 11.6528L16.4391 11.6527C16.2182 11.6527 16.0391 11.4736 16.0391 11.2527V9.80886C16.0391 9.58794 16.2182 9.40885 16.4391 9.40885H16.8081C17.029 9.40885 17.2081 9.58794 17.2081 9.80885V10.5308H18.4081V9.80885C18.4081 8.9252 17.6917 8.20885 16.8081 8.20885H16.4391Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.92571 8.25622L5.65803 16.1639H6.87335L7.21805 14.0137H8.30895L8.66001 16.1639H9.87589L8.58485 8.25622H6.92571ZM8.11303 12.8137L7.75852 10.6423L7.41043 12.8137H8.11303Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgAbs;
